import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import { RootState } from '../store'

const initialState = {
    sideMenuState: "full",
    fullscreenEnabled: false,
    homeMobileMenuShown: false,
    searchModalOpen: false,
}

const app = createSlice({

    name:"app",
    initialState,
    reducers:{
        toggleSideMenuState: (state: typeof initialState)=>{
            state.sideMenuState = state.sideMenuState === "full" ? "shrinked": "full"
        },
        toggleFullscreenMode: (state: typeof initialState)=>{
            state.fullscreenEnabled = state.fullscreenEnabled === true ? false : true
        },
        toggleHomeMobileMenuShown : (state: typeof initialState)=>{
            state.homeMobileMenuShown = state.homeMobileMenuShown === true ? false : true
        },
        
        toggleSearchModalOpen: (state: typeof initialState)=>{
            state.searchModalOpen = state.searchModalOpen === true ? false : true
        },
        setSearchModalState: (state: typeof initialState,actions: PayloadAction<boolean>)=>{
            state.searchModalOpen = actions.payload
        }
    }

})

export const appActions = app.actions
export const selectSideMenuState = (state:RootState)=>state.app.sideMenuState
export const selectFullscreenEnabled = (state:RootState)=>state.app.fullscreenEnabled
export const selectHomeMobileMenuShown = (state:RootState)=>state.app.homeMobileMenuShown
export const selectSearchModalOpen = (state:RootState)=>state.app.searchModalOpen

export default app.reducer